<script>
import Profile from './Profile.vue';
import Services from './Services.vue';
import Reviews from './Reviews.vue';




export default {
  name: 'App',
  components: {
    Profile,
    Services,
    Reviews
  }
}
</script>

<template>
<Profile />
<Services />
<Reviews />

</template>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
